import { STENCIL_MODES } from '../../shared/state/const.mjs';

"use strict";
class GpuRenderTarget {
  constructor() {
    this.contexts = [];
    this.msaaTextures = [];
    this.msaaSamples = 1;
    /**
     * The stencil state the stencil system and the mask pipe track for this target on this renderer.
     * It lives here rather than in a uid-keyed record so it is restored when the target is bound again
     * and freed with the backend object when the target dies.
     */
    this.stencilMode = STENCIL_MODES.DISABLED;
    /** the stencil reference value that goes with `stencilMode` */
    this.stencilReference = 0;
    /** how many stencil masks are currently pushed on this target */
    this.maskStackIndex = 0;
  }
}

export { GpuRenderTarget };
//# sourceMappingURL=GpuRenderTarget.mjs.map
